import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'

const Home               = lazy(() => import('./pages/Home'))
const Personas           = lazy(() => import('./pages/Personas'))
const Arrendamiento      = lazy(() => import('./pages/Arrendamiento'))
const Empresas           = lazy(() => import('./pages/Empresas'))
const Multirriesgo       = lazy(() => import('./pages/Multirriesgo'))
const Transporte         = lazy(() => import('./pages/Transporte'))
const Sustraccion        = lazy(() => import('./pages/Sustraccion'))
const ProteccionDigital  = lazy(() => import('./pages/ProteccionDigital'))
const VidaGrupo          = lazy(() => import('./pages/VidaGrupo'))
const Nosotros           = lazy(() => import('./pages/Nosotros'))
const Noticias           = lazy(() => import('./pages/Noticias'))
const Contacto           = lazy(() => import('./pages/Contacto'))
const Arl                = lazy(() => import('./pages/Arl'))
const Sgsst              = lazy(() => import('./pages/Sgsst'))
const Mascotas           = lazy(() => import('./pages/Mascotas'))
const Descargas          = lazy(() => import('./pages/Descargas'))
const Testimonios        = lazy(() => import('./pages/Testimonios'))
const Admin              = lazy(() => import('./pages/Admin'))
const DocumentosDescarga = lazy(() => import('./pages/DocumentosDescarga'))
const ArlPrograma        = lazy(() => import('./pages/ArlPrograma'))
const ClienteLogin       = lazy(() => import('./pages/ClienteLogin'))
const ClientePortal      = lazy(() => import('./pages/ClientePortal'))
// E-13 / P-08: seguros añadidos por solicitud de la clienta (correo 2026-07)
const Copropiedades      = lazy(() => import('./pages/Copropiedades'))
const RceParqueaderos    = lazy(() => import('./pages/RceParqueaderos'))
const RceProfesional     = lazy(() => import('./pages/RceProfesional'))
const AccidentesEscolares= lazy(() => import('./pages/AccidentesEscolares'))
const RceHotelera        = lazy(() => import('./pages/RceHotelera'))
const BicisPatinetas     = lazy(() => import('./pages/BicisPatinetas'))
const VidaHogarDeudor    = lazy(() => import('./pages/VidaHogarDeudor'))
const ConciliacionDeudasArl = lazy(() => import('./pages/ConciliacionDeudasArl'))

export default function App() {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="programa-arl"   element={<ArlPrograma />} />
        <Route path="iniciar-sesion" element={<ClienteLogin />} />
        <Route path="mi-cuenta"      element={<ClientePortal />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="personas" element={<Personas />} />
          <Route path="personas/arrendamiento" element={<Arrendamiento />} />
          <Route path="personas/bicis-patinetas" element={<BicisPatinetas />} />
          <Route path="personas/vida-hogar-deudor" element={<VidaHogarDeudor />} />
          <Route path="empresas" element={<Empresas />} />
          <Route path="empresas/multirriesgo" element={<Multirriesgo />} />
          <Route path="empresas/transporte" element={<Transporte />} />
          <Route path="empresas/sustraccion" element={<Sustraccion />} />
          <Route path="empresas/proteccion-digital" element={<ProteccionDigital />} />
          <Route path="empresas/vida-grupo" element={<VidaGrupo />} />
          <Route path="empresas/copropiedades" element={<Copropiedades />} />
          <Route path="empresas/rce-parqueaderos" element={<RceParqueaderos />} />
          <Route path="empresas/rce-profesional" element={<RceProfesional />} />
          <Route path="empresas/accidentes-escolares" element={<AccidentesEscolares />} />
          <Route path="empresas/rce-hotelera" element={<RceHotelera />} />
          <Route path="nosotros" element={<Nosotros />} />
          <Route path="noticias" element={<Noticias />} />
          <Route path="contacto" element={<Contacto />} />
          <Route path="arl" element={<Arl />} />
          <Route path="conciliacion-deudas-presuntas-con-la-arl" element={<ConciliacionDeudasArl />} />
          {/* URL antigua, usada brevemente antes de moverse a la ruta de arriba */}
          <Route path="arl/conciliacion-deudas-presuntas" element={<Navigate to="/conciliacion-deudas-presuntas-con-la-arl" replace />} />
          <Route path="sgsst" element={<Sgsst />} />
          <Route path="mascotas" element={<Mascotas />} />
          <Route path="descargas" element={<Descargas />} />
          <Route path="testimonios" element={<Testimonios />} />
          <Route path="admin" element={<Admin />} />
          <Route path="admin/documentos" element={<DocumentosDescarga />} />
        </Route>
      </Routes>
    </Suspense>
  )
}
